'use client';

import { ImageIcon } from 'lucide-react';
import { Button } from '../../../ui/button';
import { useToolbarContext } from '../../context/toolbar-context';
import { InsertImageDialog } from '../images-plugin';

export function ImageToolbarPlugin() {
  const { activeEditor, showModal, onImageUpload } = useToolbarContext();

  return (
    <Button
      onClick={(_e) => {
        showModal('Insert Image', (onClose) => (
          <InsertImageDialog
            activeEditor={activeEditor}
            onClose={onClose}
            onImageUpload={onImageUpload}
          />
        ));
      }}
      variant={'outline'}
      size={'icon-sm'}
      className=""
    >
      <ImageIcon className="size-4" />
    </Button>
  );
}
